import { render, staticRenderFns } from "./hotelPlansDetails.vue?vue&type=template&id=532ba5bc"
import script from "./hotelPlansDetails.vue?vue&type=script&lang=js"
export * from "./hotelPlansDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports